<template>
  <div class="end-time-page">
    <div class="icon-clock"><icon-clock /></div>

    <div class="title">{{ $tr('interview.tests.endTime.title') }}</div>

    <div class="description">{{ $tr('interview.tests.endTime.answersSend') }}</div>

    <div class="buttons-group">
      <div v-if="!only_test" class="button green" @click="next_stage">
        {{ $tr('interview.tests.endTime.next') }}
      </div>

      <router-link :to="`/interviews/${token}`" class="button">{{ $tr('interview.tests.end.toVacancy') }}</router-link>
    </div>
  </div>
</template>
<script>
/*
  Время закончилось
*/
import { mapGetters } from 'vuex';
import { STORE_PREFIX } from '../../constants.js';
import IconClock from '@/components_new/svgs/icon-clock.vue';

export default {
  name: 'EndTime',

  components: { IconClock },

  props: {
    is_last: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'test', ['token']),

    ...mapGetters(STORE_PREFIX + 'interview', {
      item: 'item'
    }),

    module_test() {
      if (!this.item.active_modules) {
        return false;
      }
      return this.item.active_modules.find(el => el.id === 'test');
    },

    only_test() {
      if (!this.module_test) {
        return false;
      }
      return this.item.active_modules.length === 1 && this.module_test.id === 'test';
    }
  },

  methods: {
    next_stage() {
      this.$store.commit('interview/videointerview/next_stage');
      this.$router.push({ path: `/interviews/${this.token}` });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.end-time-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: #233346;

  .icon-clock {
    margin: 20px auto;
  }

  .title {
    font-weight: 500;
    font-size: 28px;
    line-height: 41px;
    margin: 10px auto;
  }

  .description {
    font-size: 15px;
    line-height: 22px;
    margin: 10px auto 40px;
  }

  .buttons-group {
    display: flex;
    align-items: center;
  }

  .button {
    @include mixin-text-main;
    display: block;
    color: $green;
    background: #f4f5f7;
    padding: 12px 20px;
    text-align: center;
    min-width: 190px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: 10px 10px 20px;
    transition: all 0.3s;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      color: $green-hover;
      background: darken(#f4f5f7, 5%);
      transition: all 0.3s;
    }

    &.green {
      background: $green;
      color: white;
    }
  }
}
</style>
